import { setPageStateById } from '../PageContext';

export const makeSectionVisible = (setState: setPageStateById) => (key: number) => {
  setState('MAKE_SECTION_VISIBLE', (s) => {
    const newSectionsVisible = [...s.sectionsVisible];
    if (!newSectionsVisible.includes(key)) newSectionsVisible.push(key);
    return {
      ...s,
      sectionsVisible: newSectionsVisible,
    };
  });
};
